module.exports = __webpack_public_path__ + "static/media/hitbtc_logo.5556006e.svg";